var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona_azione_rapide",
    "data-name": "icona azione rapide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fulmine",
    d: "M30,6H27.869l2.963-4.445A1,1,0,0,0,30,0H25a1,1,0,0,0-.868.5l-4,7A1,1,0,0,0,21,9h3.277l-3.145,5.5a1,1,0,0,0,1.575,1.2l8-8A1,1,0,0,0,30,6Zm-8,9,3.641-6.371V8.5a.5.5,0,0,0-.5-.5H21l4-7h5L26.553,6.172a.954.954,0,0,0-.115.328.5.5,0,0,0,.5.5H30Z",
    transform: "translate(-18)",
    fill: "#337ab7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1943",
    "data-name": "Rettangolo 1943",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeAction);
export default __webpack_public_path__ + "static/media/pipe_action.9722be5de72b247544c39c5f8c507680.svg";
export { ForwardRef as ReactComponent };